import { Helmet } from 'react-helmet-async';

const CONTACT = 'contact@lodonu.dev';

// The only prose / marketing surface in the workspace.
function About() {
  return (
    <>
      <Helmet>
        <title>About · VantageLabs</title>
        <meta
          name="description"
          content="VantageLabs is a working studio for in-browser computer-vision tools. No uploads, no server — every tool runs locally on your machine."
        />
        <link rel="canonical" href="https://vantage.lodonu.dev/about" />
      </Helmet>

      <div className="ws-pane-head">
        <span className="ws-pane-title ws-accent-italic">About</span>
        <span className="ws-crumbs">/ a practice, not a product</span>
        <span className="ws-pane-spacer" />
        <span className="mono">v0.4 · MMXXVI</span>
      </div>

      <div className="ws-pane-body ws-about-body">
        <div className="ws-about">
          <div className="mono ws-about-eyebrow">
            <span className="ws-about-rule" />
            Notes from the lab
          </div>

          <h1 className="ws-about-h1">
            Teaching machines<br />
            to <span className="ws-accent-italic">see</span> what we see.
          </h1>

          <p>
            VantageLabs began as a sandbox for drone footage. It has since
            broadened into a working studio for computer-vision systems on any
            image — streets, studios, manuscripts, kitchens.
          </p>
          <p>
            The instrument you're in is built end to end in the browser. No
            uploads, no server. Each tool is a small artefact you can try, tear
            apart, and run locally.
          </p>
          <p>
            Today only the Frame Extractor is wired up; the rest of the roadmap
            is sketched into the sidebar so you can see where this is going.
            Code, weights, and the things that didn't work are all written down.
          </p>

          <div className="ws-about-stats">
            <div>
              <div className="ws-about-k">1</div>
              <div className="ws-about-v">Tool live today</div>
            </div>
            <div>
              <div className="ws-about-k">0</div>
              <div className="ws-about-v">Bytes uploaded · in-browser</div>
            </div>
            <div>
              <div className="ws-about-k">MIT</div>
              <div className="ws-about-v">License, where I can</div>
            </div>
          </div>

          <div className="ws-about-contact">
            <span className="mono">Get in touch</span>
            <a href={`mailto:${CONTACT}`} className="ws-about-email">
              {CONTACT} ↗
            </a>
            <span className="ws-pane-spacer" />
            <span className="mono">© MMXXVI</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
